import { combineEpics, Epic, ofType } from "redux-observable";
import { Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { AuthActions } from "./actions";
import { AuthDTO } from "./models/dto";
import { AuthService } from "./service";

const auth: Epic<AuthActions.Actions> = (action$) =>
  action$.pipe(
    ofType(AuthActions.ActionTypes.authRequest),
    switchMap<
      AuthActions.AuthRequest,
      Promise<FetchableError | FetchableSuccess<AuthDTO.Responses.Login.T>>
    >(({ payload }) => AuthService.postLogin(payload)),
    map(AuthActions.authDone)
  );

const logout: Epic<AuthActions.Actions> = (action$) =>
  action$.pipe(
    ofType(AuthActions.ActionTypes.logout),
    switchMap<AuthActions.Logout, Promise<void>>(() => AuthService.logout()),
    map(() => AuthActions.clearAuthState())
  );

const impersonate: Epic<AuthActions.Actions> = (action$) =>
  action$.pipe(
    ofType(AuthActions.ActionTypes.impersonateRequest),
    switchMap<
      AuthActions.ImpersonateRequest,
      Promise<FetchableError | FetchableSuccess<AuthDTO.Responses.Login.T>>
    >(({ payload }) => AuthService.impersonate(payload)),
    map(AuthActions.authDone)
  );

const stopImpersonation: Epic<AuthActions.Actions> = (action$) =>
  action$.pipe(
    ofType(AuthActions.ActionTypes.stopImpersonationRequest),
    switchMap<
      AuthActions.StopImpersonationRequest,
      Promise<FetchableError | FetchableSuccess<AuthDTO.Responses.Login.T>>
    >(() => AuthService.stopImpersonation()),
    map(AuthActions.authDone)
  );

export const authEpic = combineEpics(
  auth,
  logout,
  impersonate,
  stopImpersonation
);
